<template>
    <div>
        <UiCardListHeader :title="lang('congresses::ticket-orders.widgets.walk_in.title')" />

        <div>
            <UiCardEmpty v-if="congresses.length === 0">
                {{ lang('congresses::ticket-orders.widgets.walk_in.no_congresses') }}
            </UiCardEmpty>

            <Button v-else type="button" color="default" class="w-full quick-action" @click="goToWalkIn">
                <Icon icon="phosphor/regular/door-open" class="w-4 h-4 mr-2" />
                {{ lang('congresses::ticket-orders.widgets.walk_in.button') }}
                <KbdShortcut keys="Alt+W" size="sm" class="ml-2" />
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import { router } from '@inertiajs/vue3';
import { onKeyStroke } from '@vueuse/core';
import KbdShortcut from '@src/Common/Components/KbdShortcut.vue';

interface CongressOption {
    id: number;
    title: string;
    start_date: string | null;
    end_date: string | null;
}

interface WidgetData {
    congresses?: CongressOption[];
}

const props = defineProps<{ slug?: string; settings?: object; data?: WidgetData }>();

const congresses: Ref<CongressOption[]> = ref(props.data?.congresses ?? []);

function goToWalkIn(): void {
    router.visit(route('congresses.admin.walk-in'));
}

onKeyStroke(true, (e) => {
    if (e.code !== 'KeyW' || !e.altKey) return;
    if (congresses.value.length === 0) return;
    e.preventDefault();
    goToWalkIn();
});
</script>
